<!--
 * @Description: file content
 * @Author: liujunyao
 * @Date: 2022-04-19 16:06:42
 * @LastEditors: liujunyao
 * @LastEditTime: 2022-04-20 10:20:20
 * @FilePath: /privacy-web/src/components/The/TheDropdown.vue
-->
<template>
  <div>
    <el-dropdown trigger="click" :hide-on-click="true" @command="handleCommand">
      <div class="dropdown-mobile"></div>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item
          v-for="item in menusList"
          :key="item.key"
          :command="item.path"
          >{{ item.name }}</el-dropdown-item
        >
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>
<script>
export default {
  name: "TheDropdown",
  data() {
    return {
      menusList: [
        {
          path: "/home-page-tile",
          name: "首页",
          key: "home-page-tile",
        },
        {
          path: "/privacy-manage",
          name: "隐私管理",
          key: "privacy-manage",
        },
        {
          path: "/privacy-protect",
          name: "隐私保护",
          key: "privacy-protect",
        },
        {
          path: "/privacy-policy",
          name: "隐私政策",
          key: "privacy-policy",
        },
        {
          path: "/privacy-attestation",
          name: "用户中心",
          key: "privacy-attestation",
        },
      ],
    };
  },
  methods: {
    handleCommand(command) {
      this.$router.push({ path: command });
    },
  },
};
</script>
<style scoped lang="scss">
.el-dropdown {
  display: flex;
  justify-content: center;
  align-items: center;
}

.dropdown-mobile {
  margin: auto;
  width: 1.23rem;
  height: 1.23rem;
  background: url("@/assets/images/dropdown.png") 100% no-repeat;
  background-size: cover;
}

.el-dropdown-menu {
  left: 13.2rem !important;
  border: 0;
  width: 6rem;
  background: rgb(9 75 150 / 63%);
  backdrop-filter: blur(0.36rem);

  .el-dropdown-menu__item {
    font-size: 0.82rem;
    text-align: center;
    color: #fff;
    line-height: 1.5rem;
  }
}

.el-popper {
  ::v-deep .popper__arrow {
    display: none !important;
  }
}
</style>
